<template>
  <AdminLayout
    title="Dashboard"
    menu="Dashboard"
    :customStyle="{ backgroundColor: '#fcfcfc' }"
  >
    <div class="row">
      <div class="col-lg-6">
        <img
          src="/images/mappit.png"
          width="140px"
        />
        <span class="ml-3">
          Data Atual: {{current_date}}
        </span>
      </div>
      <div
        class="col-lg-6"
        style="text-align: right;"
      >
        <a href="/recruiters/export_corteva.csv">
          <button class="btn btn-primary mr-4">
            Download candidatos
          </button>
        </a>
        <button
          @click="generateReport"
          class="btn btn-primary mr-4"
        >
          Download relatório
        </button>
        <img
          src="/images/corteva.png"
          width="200px"
        />

      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <table class="table">
          <tr>
            <td>
              SUMMARY
            </td>
            <td>

            </td>
            <td>
              Total de candidatos inscritos
            </td>
            <td>
              Candidatos internos
            </td>
            <td>
              Candidatos inscritos do processo anterior
            </td>
            <td>
              Mulheres
            </td>
          </tr>
          <tr>
            <td>
              Oeste
            </td>
            <td>
              Allyado / Personali*
            </td>
            <td>
              {{candidate_oeste}}
              <!-- Total de candidatos inscritos -->
            </td>
            <td>
              <!-- Candidatos internos -->
              {{candidate_internal_oeste}}
            </td>
            <td>
              {{ candidate_oeste_old }}
              <!-- Candidatos inscritos do processo anterior -->
            </td>
            <td>
              {{ woman_oeste }}
              ({{ ((woman_oeste * 100 ) / candidate_oeste).toFixed(2)}}%)
              <!-- mulheres -->
            </td>
          </tr>
          </tr>
          <tr>
            <td>
              Centro Norte
            </td>
            <td>
              Allyado
            </td>
            <td>
              <!-- Total de candidatos inscritos -->
              {{candidate_centro_norte}}
            </td>
            <td>
              {{candidate_internal_centro_norte}}
              <!-- Candidatos internos -->
            </td>
            <td>
              {{ candidate_centro_norte_old }}
              <!-- Candidatos inscritos do processo anterior -->
            </td>
            <td>
              {{ woman_centro_norte }}

              ({{ ((woman_centro_norte * 100 ) / candidate_centro_norte).toFixed(2)}}%)
              <!-- mulheres -->
            </td>
          </tr>
          </tr>
          <tr>
            <td>
              Brasil
            </td>
            <td>

            </td>
            <td>
              {{candidate_oeste + candidate_centro_norte}}
              <!-- Total de candidatos inscritos -->
            </td>
            <td>
              {{candidate_internal_oeste + candidate_internal_centro_norte}}
              <!-- Candidatos internos -->
            </td>
            <td>
              {{ candidate_centro_norte_old + candidate_oeste_old }}
              <!-- Candidatos inscritos do processo anterior -->
            </td>
            <td>
              {{ woman_centro_norte +  woman_oeste }}
              ({{ (((woman_centro_norte + woman_oeste) * 100 ) / (candidate_centro_norte+candidate_oeste)).toFixed(2)}}%)
              <!-- mulheres -->
            </td>
          </tr>

        </table>
      </div>
    </div>

    <div class="row mt-3 hide">

      <div class="col-lg-3">
        <div class="bg-aqua py-3 pl-3 pr-0 radius-4">
          <span class="f40 d-block">
            <b>{{amount_apply}}</b>
          </span>
          <span class="f10 d-block">
            Total de candidatos
          </span>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="bg-aqua p-4 mt-4 radius-4">
          <span class="color-primary  label-bold">ENGAJAMENTO DE CANDIDATOS(AS)</span>
          <Graph
            class="mt-2"
            getFrom="/recruiters/applies_corteva"
            :height="200"
          />
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="bg-aqua p-4 mt-4 radius-4">
          <span class="color-primary label-bold">CANDIDATOS POR GÊNERO</span>
          <div class="row mt-2">
            <div
              class="col-lg-5"
              style="text-align: right"
            >
              <p class="mt-4">Homens - {{ ( (gender_amount[0] * 100) / gender_total).toFixed(2) }}%</p>
              <p>Mulheres - {{ ((gender_amount[1] * 100) / gender_total).toFixed(2) }}%</p>
              <p>Transgeneros - {{ ((gender_amount[2] * 100) / gender_total).toFixed(2)}}%</p>
              <p>Não quer identificar - {{ ((gender_amount[3] * 100) / gender_total).toFixed(2)}}%</p>

            </div>
            <div class="col-lg-7">
              <DoughnutChart
                :chart-data="chartData"
                :options="options"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 hide">
        <div class="bg-aqua py-3 mt-4 pl-3 pr-0 radius-4">
          <span class="f40 d-block">
            <b>{{old_candidates}}</b>
          </span>
          <span class="f10 d-block">
            CANDIDATOS PROCESSO ANTERIOR
          </span>
        </div>
        <div class="bg-aqua py-3 mt-4 pl-3 pr-0 radius-4">
          <span class="f40 d-block">
            <b>{{candidate_work_corteva}}</b>
          </span>
          <span class="f10 d-block">
            CANDIDATOS INTERNOS
          </span>
        </div>

        <div class="bg-aqua py-3 mt-4 pl-3 pr-0 radius-4">
          <span class="f40 d-block">
            <b>{{candidate_centro_norte}}</b>
          </span>
          <span class="f10 d-block">
            Centro-Norte (PI MA TO PA BA GO DF)
          </span>
        </div>

        <div class="bg-aqua py-3 mt-4 pl-3 pr-0 radius-4">
          <span class="f40 d-block">
            <b>{{candidate_oeste}}</b>
          </span>
          <span class="f10 d-block">
            Oeste (MT MS RO)
          </span>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="bg-aqua p-4 mt-4 radius-4">
          <span class="color-primary label-bold">CANDIDATOS POR ESTADO/CIDADE</span>

          <div class="row mt-2">
            <template v-for="(candidate_state, index) in candidate_states">
              <div
                v-if="candidate_state.state_uf != null"
                class="col-lg-3 "
                :key="candidate_state.state_uf"
              >
                {{candidate_state.state_name}} ( {{candidate_state.amount}} )
                <table
                  class="table"
                  style="font-size: 10px !important;"
                >
                  <template v-for="(candidate_city, index) in candidate_cities">
                    <tr
                      class="p-0 m-0"
                      style="padding: 0px !important;"
                      v-if=" candidate_state.state_uf ==candidate_city.state_uf"
                      :key="candidate_city.city_name"
                    >
                      <td
                        class="p-0 m-0"
                        style="padding: 0px !important;"
                      >
                        {{candidate_city.city_name}}
                      </td>
                      <td
                        class="p-0 m-0"
                        style="padding: 0px !important;"
                      >
                        {{candidate_city.amount}}
                      </td>
                    </tr>

                  </template>

                </table>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="bg-aqua  p-4 mt-4 radius-4">
          <span class="color-primary label-bold">CANDIDATOS INTERNOS</span>
          <table
            class="table"
            style="font-size: 9px;"
          >
            <tr>
              <td>Nome</td>
              <td>Email</td>
              <td>Telefone</td>
              <td>Cidade</td>
              <td>Empresa</td>
              <td>Cargo</td>
            </tr>
            <tr
              v-for="candidate in candidate_work_corteva_list"
              :key="candidate.id"
            >
              <td>
                {{candidate.name}}
              </td>
              <td>
                {{candidate.email}}
              </td>
              <td>
                {{candidate.mobile_phone}}
              </td>
              <td>
                {{candidate.city_name}}/{{candidate.state_uf}}
              </td>
              <td>
                {{candidate.last_business}}
              </td>
              <td>
                {{candidate.last_role}}
              </td>
            </tr>

          </table>
        </div>

      </div>
    </div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1500"
      filename="corteva"
      :pdf-quality="5"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="760px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >

      <section slot="pdf-content">

        <section class="pdf-item pl-4 pr-4 pt-5">
          <div class="row">
            <div class="col-lg-7">
              <img
                src="/images/mappit.png"
                width="140px"
              />
              <span class="ml-3">
                Data Atual: {{current_date}}
              </span>
            </div>
            <div
              class="col-lg-5"
              style="text-align: right;"
            >
              <img
                src="/images/corteva.png"
                width="200px"
              />
            </div>
          </div>
        </section>
        <section class="pdf-item pl-4 pr-4">
          <div class="row mt-3">

            <div class="col-lg-12">
              <table class="table">
                <tr>
                  <td>
                    SUMMARY
                  </td>
                  <td>

                  </td>
                  <td>
                    Total de candidatos inscritos
                  </td>
                  <td>
                    Candidatos internos
                  </td>
                  <td>
                    Candidatos inscritos do processo anterior
                  </td>
                  <td>
                    Mulheres
                  </td>
                </tr>
                <tr>
                  <td>
                    Oeste
                  </td>
                  <td>
                    Allyado / Personali*
                  </td>
                  <td>
                    {{candidate_oeste}}
                    <!-- Total de candidatos inscritos -->
                  </td>
                  <td>
                    <!-- Candidatos internos -->
                    {{candidate_internal_oeste}}
                  </td>
                  <td>
                    {{ candidate_oeste_old }}
                    <!-- Candidatos inscritos do processo anterior -->
                  </td>
                  <td>
                    {{ woman_oeste }}
                    ({{ ((woman_oeste * 100 ) / candidate_centro_norte).toFixed(2)}}%)
                    <!-- mulheres -->
                  </td>
                </tr>
                </tr>
                <tr>
                  <td>
                    Centro Norte
                  </td>
                  <td>
                    Allyado
                  </td>
                  <td>
                    <!-- Total de candidatos inscritos -->
                    {{candidate_centro_norte}}
                  </td>
                  <td>
                    {{candidate_internal_centro_norte}}
                    <!-- Candidatos internos -->
                  </td>
                  <td>
                    {{ candidate_centro_norte_old }}
                    <!-- Candidatos inscritos do processo anterior -->
                  </td>
                  <td>
                    {{ woman_centro_norte }}

                    ({{ ((woman_centro_norte * 100 ) / candidate_centro_norte).toFixed(2)}}%)
                    <!-- mulheres -->
                  </td>
                </tr>
                </tr>
                <tr>
                  <td>
                    Brasil
                  </td>
                  <td>

                  </td>
                  <td>
                    {{candidate_oeste + candidate_centro_norte}}
                    <!-- Total de candidatos inscritos -->
                  </td>
                  <td>
                    {{candidate_internal_oeste + candidate_internal_centro_norte}}
                    <!-- Candidatos internos -->
                  </td>
                  <td>
                    {{ candidate_centro_norte_old + candidate_oeste_old }}
                    <!-- Candidatos inscritos do processo anterior -->
                  </td>
                  <td>
                    {{ woman_centro_norte +  woman_oeste }}
                    ({{ (((woman_centro_norte + woman_oeste) * 100 ) / (candidate_centro_norte+candidate_oeste)).toFixed(2)}}%)
                    <!-- mulheres -->
                  </td>
                </tr>

              </table>

            </div>

          </div>
        </section>
        <section class="pdf-item pl-4 pr-4">
          <div class="row">
            <div class="col-lg-12">
              <div class="bg-aqua p-4 mt-4 radius-4">
                <span class="color-primary  label-bold">ENGAJAMENTO DE CANDIDATOS(AS)</span>
                <Graph
                  class="mt-2"
                  getFrom="/recruiters/applies_corteva"
                  :height="200"
                />
              </div>
            </div>

          </div>

        </section>

        <section class="pdf-item pl-4 pr-4">
          <div class="row">
            <div class="col-lg-8">
              <div class="bg-aqua p-4 mt-4 radius-4">
                <span class="color-primary label-bold">CANDIDATOS POR GÊNERO</span>
                <div class="row mt-2">
                  <div
                    class="col-lg-5"
                    style="text-align: right"
                  >
                    <p class="mt-4">Homens - {{ ((gender_amount[0] * 100) / gender_total).toFixed(2) }}%</p>
                    <p>Mulheres - {{ ((gender_amount[1] * 100) / gender_total).toFixed(2) }}%</p>
                    <p>Transgêneros - {{ ((gender_amount[2] * 100) / gender_total).toFixed(2)}}%</p>
                    <p>Não quer identificar - {{ ((gender_amount[3] * 100) / gender_total).toFixed(2)}}%</p>

                  </div>
                  <div class="col-lg-7">
                    <DoughnutChart
                      :chart-data="chartData"
                      :options="options"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section class="pdf-item pl-4 pr-4">
          <div class="row">
            <div class="col-lg-12">
              <div class="bg-aqua p-4 mt-4 radius-4">
                <span class="color-primary label-bold">CANDIDATOS POR ESTADO/CIDADE</span>

                <div class="row">
                  <template v-for="(candidate_state,index) in candidate_states">

                    <div
                      v-if="candidate_state.state_uf != null"
                      class="col-lg-3 "
                      :key="candidate_state.state_uf"
                    >
                      <span style="font-size: 11px !important;">
                        {{candidate_state.state_name}} ( {{candidate_state.amount}} )
                      </span>
                      <table
                        class="table"
                        style="font-size: 9px;"
                      >
                        <template v-for="candidate_city in candidate_cities">
                          <tr
                            class="p-0 m-0"
                            style="padding: 0px !important;"
                            v-if=" candidate_state.state_uf ==candidate_city.state_uf"
                            :key="candidate_city.city_name"
                          >
                            <td
                              class="p-0 m-0"
                              style="padding: 0px !important;"
                            >
                              {{candidate_city.city_name}}
                            </td>
                            <td
                              class="p-0 m-0"
                              style="padding: 0px !important;"
                            >
                              {{candidate_city.amount}}
                            </td>
                          </tr>
                        </template>
                      </table>
                    </div>

                  </template>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="pdf-item pl-4 pr-4">
          <div class="row">
            <div class="col-lg-12">

              <div class="bg-aqua  p-4 mt-4 radius-4">
                <span class="color-primary label-bold">CANDIDATOS INTERNOS</span>
                <table
                  class="table"
                  style="font-size: 9px;"
                >
                  <tr>
                    <td>Nome</td>
                    <td>Email</td>
                    <td>Telefone</td>
                    <td>Cidade</td>
                    <td>Empresa</td>
                    <td>Cargo</td>
                    <td>Vaga</td>
                  </tr>
                  <tr
                    v-for="candidate in candidate_internal_oeste"
                    :key="candidate.id"
                  >
                    <td>
                      {{candidate.name}}
                    </td>
                    <td>
                      {{candidate.email}}
                    </td>
                    <td>
                      {{candidate.mobile_phone}}
                    </td>
                    <td>
                      {{candidate.city_name}}/{{candidate.state_uf}}
                    </td>
                    <td>
                      {{candidate.last_business}}
                    </td>
                    <td>
                      {{candidate.last_role}}
                    </td>
                    <td>
                      {{candidate.job_title}}
                    </td>
                  </tr>

                </table>
              </div>

            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>

  </AdminLayout>
</template>

<script>
import AdminLayout from "layouts/AdminRecruiter.vue";
import Graph from "components/Graph.vue";
import PercentageCircle from "components/PercentageCircle.vue";
import DoughnutChart from "components/DoughnutChart.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  props: [
    "amount_apply",
    "selective_process_amount",
    "gender_amount",
    "gender_total",
    "current_date",
    "candidate_states",
    "candidate_cities",
    "old_candidates",
    "candidate_work_corteva",
    "candidate_work_corteva_list",
    "candidate_centro_norte",
    "candidate_oeste",
    "candidate_internal_oeste",
    "candidate_internal_centro_norte",
    "candidate_centro_norte_old",
    "candidate_oeste_old",
    "woman_oeste",
    "woman_centro_norte",
  ],
  components: {
    AdminLayout,
    Graph,
    PercentageCircle,
    VueHtml2pdf,
    DoughnutChart,
  },
  data() {
    return {
      options: {
        responsive: true,
        hover: {
          animationDuration: 0, // duration of animations when hovering an item
        },
        responsiveAnimationDuration: 0,
        animation: {
          duration: 0,
        },
      },
      chartData: {
        labels: ["Homen", "Mulher", "Transgenero", "Não quer informar"],

        datasets: [
          {
            backgroundColor: ["#9570fd", "#6af1ff", "#2f2f2f", "#667d89"],
            data: [
              (this.gender_amount[0] * 100) / this.gender_total,
              (this.gender_amount[1] * 100) / this.gender_total,
              (this.gender_amount[2] * 100) / this.gender_total,
              (this.gender_amount[3] * 100) / this.gender_total,
            ],
          },
        ],
      },
    };
  },
  mounted() {
    this.chartData.datasets[0].data = [
      (this.gender_amount[0] * 100) / this.gender_total,
      (this.gender_amount[1] * 100) / this.gender_total,
      (this.gender_amount[2] * 100) / this.gender_total,
      (this.gender_amount[3] * 100) / this.gender_total,
    ];
    console.log(this.gender_amount);
    console.log(this.gender_total);
    console.log(this.chartData.datasets);
  },
  methods: {
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>
